import { makeLinkWithQueryParams } from '../intents/linkUtils';
import { marketPlaceProviders } from './productLinks';
import { getPortalId } from '../store/auth/selectors';
import { getHublet } from '../store/app/selectors';
export const getDirectoryListingRedirect = state => {
  const portalId = getPortalId(state);
  const hublet = getHublet(state);
  return makeLinkWithQueryParams({
    link: marketPlaceProviders({
      portalId,
      hublet
    }),
    hublet,
    queryParamsToInclude: {
      via: 'directory-listing-signup'
    }
  });
};